import React from 'react'
import Navbar from './Navbar'
import Section from './Section'

function Section1() {
  return (
    <div className="pb-[120px]  bg-[#f5df4e] ">
    <Navbar/>
    <Section/>
    </div>
  )
}

export default Section1